import styles from './LoadingSpinner.css'

class LoadingSpinner extends React.Component {
  render () {
    let {showLoadingSpinner} = this.props
    return (showLoadingSpinner &&
      <div className={styles['loading-container']}>
        <img src={require('assets/images/loading-simple.gif')} alt='mokapos spinner' className='loading-spinner' />
      </div>
    )
  }
}

LoadingSpinner.propTypes = {
  showLoadingSpinner: React.PropTypes.bool
}

export default LoadingSpinner



// WEBPACK FOOTER //
// ./app/components/LoadingSpinner/LoadingSpinner.js